import React from "react";

import { usePreviewBox } from "../../../hooks/usePreviewBox";

import { FloatingBar } from "../../floating-bar";

export function TopMenuBar({ children }: { children: React.ReactNode }) {
	const { previewBox } = usePreviewBox();

	const marginHorizontal = 15 * 2 + 12 * 2;
	const maxAllowedWidth = previewBox ? previewBox.width - marginHorizontal : 500;

	// Added class for e2e locator
	return (
		<FloatingBar.Bar className="top-menu-bar" maxAllowedWidth={maxAllowedWidth}>
			{children}
		</FloatingBar.Bar>
	);
}
